import React from 'react';

function MusicNoteIcon({ width = 30, height = 40, color = '#ffffff', ...props }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g transform="translate(4,2)">
                <path d="M10 1v12.2c-0.9-0.5-2-0.8-3.2-0.8-2.9 0-5.3 1.8-5.3 4s2.4 4 5.3 4 5.3-1.8 5.3-4V4.2l4.4-1V0L10 1Z" stroke={color} strokeWidth="1.7" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="6.8" cy="16.4" r="0.01" fill="none" />
            </g>
        </svg>
    );
}

export default MusicNoteIcon;

